<template>
  <fieldset>
    <div class="fieldset">
      <legend v-if="title">{{ title }}</legend>
      <slot></slot>
    </div>
  </fieldset>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  provide() {
    return {
      groupName: this.name,
      groupContext: this,
    };
  },
  methods: {
    onChange(e) {
      const data = Object.entries({ ...(this.value || {}), ...e })
        .filter(([, value]) => value)
        .reduce(
          (results, [key, value]) => Object.assign(results, { [key]: value }),
          {},
        );

      const value = Object.keys(data).length ? data : null;
      this.$emit('change', value);
    },
  },
};
</script>
